import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  margin: 0 auto;
  margin-bottom: 10px;
  flex-direction: column;
  margin-top: 10px;
  width: 100%;
  /* background: white; */

  border-radius: 10px;
  height: 100%;
  & > * {
    margin-bottom: 10px;
  }
  @media (min-width: 376px) {
  }
  @media (min-width: 769px) {
    margin-top: 0;
    padding: 20px;
  }
`;

export const ListPanels = styled.div`
  margin-bottom: 100px;
  & > * {
    margin-bottom: 20px;
  }

  @media (min-width: 769px) {
    margin-bottom: 0;
  }

  ${({ invisible }) => invisible && `opacity: 0;`}
`;

export const TopActions = styled.div`
  /* display: none; */
  /* background: white; */
  & > * {
    margin-left: 10px !important;
  }
  @media (min-width: 769px) {
    border-radius: 10px;
    margin-bottom: 20px;
    padding: 10px;
    display: flex;
    justify-content: flex-end;
  }
`;

export const NewCategory = styled.div`
  display: flex;
  & > input {
    width: 300px;
    margin-right: 10px;
  }
  @media (min-width: 426px) {
  }
`;

export const Info = styled.div`
  margin-bottom: 10px;
  padding: 10px;
  border-left: 2px solid rgb(171, 177, 32);
  background: rgba(185, 193, 36, 0.19);
  border-radius: 5px;
  @media (min-width: 426px) {
    display: none;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  & > * {
    margin-bottom: 10px !important;
 }
`;

export const ListCategoryToReorder = styled.div`
  margin-top: 20px;
  & > * {
    margin-bottom: 30px;
  }
`;

export const ItemCategoryToReorder = styled.div`
  padding: 20px;
  background: #e9ecef;
  font-size: 20px;
  font-weight: bold;
  &::after {
    content: "";
    height: 10px;
    width: 100%;
    background: white;
    position: absolute;
    left: 0;
    bottom: -10px;
    border-radius: 0px 0px 10px 10px;
  }
`;
